import { Notification, NotificationType, Session } from "../entity/entities";
import { ExecutionStatuses } from "../entity/enum/workflowExecutionStatuses";
import { isNullOrWhiteSpace, tryParseJSONObject } from "../utils/utils";

export class NotificationHelper {
  public static handleSignalRResponse(translate, message: string, failed: boolean = false, executionStatus: ExecutionStatuses = null, expirationInMS: number = null) {
    let notification: Notification;
    let notificationTitle: string;
    let notificationMessage: string;
    let notificationType: NotificationType;
    let jsonObject = tryParseJSONObject(message);
    if (jsonObject != false) {
      notificationTitle = isNullOrWhiteSpace(jsonObject.Title) ? NotificationHelper.getDefaultTitle(jsonObject.NotificationType, translate) : jsonObject.Title;
      notificationMessage = jsonObject.Message;
      notificationType = jsonObject.NotificationType as NotificationType;

      notification = new Notification(
        notificationTitle,
        notificationMessage,
        notificationType,
        notificationType == NotificationType.Success && expirationInMS == null
          ? 3000
          : expirationInMS
      );
    }
    else {
      if (executionStatus && executionStatus == ExecutionStatuses.Warning) {
        notification = new Notification(
          NotificationHelper.getDefaultTitle(NotificationType.Warning, translate),
          message,
          NotificationType.Warning,
          expirationInMS
        );
      }
      else if (failed) {
        notification = new Notification(
          NotificationHelper.getDefaultTitle(NotificationType.Error, translate),
          message,
          NotificationType.Error,
          expirationInMS
        );
      } else {
        notification = new Notification(
          NotificationHelper.getDefaultTitle(NotificationType.Success, translate),
          message,
          NotificationType.Success,
          expirationInMS ?? 3000
        );
      }
    }

    Session.notifications.add(notification.id, notification);

    return jsonObject;
  }

  private static getDefaultTitle(notificationType: NotificationType, translate): string {
    let result: string = '';

    switch (notificationType) {
      case NotificationType.Warning:
        result = translate.instant('general.warning');
        break;
      case NotificationType.Error:
        result = translate.instant('dashboard.bulkApproveAndClose.errorOccurred');
        break;
      default:
        result = translate.instant('general.ok');
        break;
    }

    return result;
  }
}
